<div
  class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2 sp-table__sticky-header">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'ORDERS.IBAN_LABEL' | translate }}</h3>
    </div>
  </div>

  <div class="sp-width__full sp-margin__top-x2 sp-overflow__y-scroll sp-padding__right-x2" style="max-height: 140px">
    <div class="sp-buyer-details-general-sdd__grid">
      <div *ngFor="let sdd_payment_source of sdd_payment_sources; let i = index"
        class="sp-payment-sources-data-list__item sp-cursor__pointer">
        <div class="sp-background__primary-light sp-padding sp-border-radius__s sp-card-container">
          <div class="sp-row__align">
            <mat-icon> account_balance </mat-icon>
            <p class="sp-margin__left">{{ 'ORDERS.IBAN_LABEL' | translate }}</p>
          </div>

          <h2 class="sp-text__center sp-margin__top sp-margin__auto">
            {{ sdd_payment_source?.qinetic_sepa_debit?.iban }}
          </h2>

          <div class="sp-row__end sp-padding__top">
            <button mat-icon-button class="sp-icon__button sp-icon__button-accent"
              [matTooltip]="'BUYERS.EDIT_IBAN_CTA' | translate"
              (click)="onEditIbanClick(sdd_payment_source); $event.stopPropagation()">
              <mat-icon class="material-symbols-outlined"> create </mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>